module.exports = __webpack_public_path__ + "img/236.a74cefdd.jpg";